import { render } from "./Archivelist.vue?vue&type=template&id=b5111a20&scoped=true"
import script from "./Archivelist.vue?vue&type=script&lang=js"
export * from "./Archivelist.vue?vue&type=script&lang=js"

import "./Archivelist.vue?vue&type=style&index=0&id=b5111a20&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5111a20"]])

export default __exports__